/**
 * components/Icons.js
 * Tiny inline stroke SVG icons (14x14) for row actions. Each inherits its button's text color via
 * stroke="currentColor" — no hard-coded fills, no icon-library dependency.
 */
import React from "react";

const base = {
  width: 14, height: 14, viewBox: "0 0 24 24", fill: "none",
  stroke: "currentColor", strokeWidth: 2,
  strokeLinecap: "round", strokeLinejoin: "round",
  "aria-hidden": true,
};

export function EyeIcon() {
  return (
    <svg {...base}>
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}

export function PencilIcon() {
  return (
    <svg {...base}>
      <path d="M12 20h9" />
      <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
    </svg>
  );
}

export function MergeIcon() {
  return (
    <svg {...base}>
      <path d="M6 3v6a6 6 0 0 0 6 6 6 6 0 0 0 6-6V3" />
      <polyline points="3 6 6 3 9 6" />
      <polyline points="15 6 18 3 21 6" />
      <line x1="12" y1="15" x2="12" y2="21" />
    </svg>
  );
}

export function TrashIcon() {
  return (
    <svg {...base}>
      <polyline points="3 6 5 6 21 6" />
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
      <line x1="10" y1="11" x2="10" y2="17" />
      <line x1="14" y1="11" x2="14" y2="17" />
    </svg>
  );
}

export function ReceiptIcon() {
  return (
    <svg {...base}>
      <path d="M6 2h12v19l-3-2-3 2-3-2-3 2V2z" />
      <line x1="9" y1="7" x2="15" y2="7" />
      <line x1="9" y1="11" x2="15" y2="11" />
      <line x1="9" y1="15" x2="13" y2="15" />
    </svg>
  );
}

export function TruckIcon() {
  return (
    <svg {...base}>
      <rect x="1" y="7" width="13" height="10" rx="1" />
      <path d="M14 10h4l3 3v4h-7z" />
      <circle cx="6" cy="19" r="1.6" />
      <circle cx="17" cy="19" r="1.6" />
    </svg>
  );
}

export function ClipboardCheckIcon() {
  return (
    <svg {...base}>
      <rect x="5" y="4" width="14" height="18" rx="2" />
      <path d="M9 2h6a1 1 0 0 1 1 1v2H8V3a1 1 0 0 1 1-1z" />
      <polyline points="9 13 11.5 15.5 16 10.5" />
    </svg>
  );
}

export function WalletIcon() {
  return (
    <svg {...base}>
      <path d="M3 7a2 2 0 0 1 2-2h13a1 1 0 0 1 1 1v3" />
      <path d="M3 7v11a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4" />
      <rect x="16" y="12" width="6" height="5" rx="1" />
      <circle cx="18.5" cy="14.5" r="0.6" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function MoreIcon() {
  return (
    <svg {...base}>
      <circle cx="5" cy="12" r="1.8" fill="currentColor" stroke="none" />
      <circle cx="12" cy="12" r="1.8" fill="currentColor" stroke="none" />
      <circle cx="19" cy="12" r="1.8" fill="currentColor" stroke="none" />
    </svg>
  );
}

/* ── Sidebar nav icons ──────────────────────────────────────────────────── */

export function DaftarBarangIcon() {
  return (
    <svg {...base}>
      <path d="M12 2 3 7v10l9 5 9-5V7z" />
      <path d="M3 7l9 5 9-5" />
      <line x1="12" y1="12" x2="12" y2="22" />
    </svg>
  );
}

export function PenjualanIcon() {
  return (
    <svg {...base}>
      <path d="M6 2h12v19l-3-2-3 2-3-2-3 2V2z" />
      <line x1="9" y1="7" x2="15" y2="7" />
      <line x1="9" y1="11" x2="15" y2="11" />
      <line x1="9" y1="15" x2="13" y2="15" />
    </svg>
  );
}

export function PembelianIcon() {
  return (
    <svg {...base}>
      <rect x="1" y="7" width="13" height="10" rx="1" />
      <path d="M14 10h4l3 3v4h-7z" />
      <circle cx="6" cy="19" r="1.6" />
      <circle cx="17" cy="19" r="1.6" />
    </svg>
  );
}

export function PiutangUtangIcon() {
  return (
    <svg {...base}>
      <path d="M3 7a2 2 0 0 1 2-2h13a1 1 0 0 1 1 1v3" />
      <path d="M3 7v11a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4" />
      <rect x="16" y="12" width="6" height="5" rx="1" />
      <circle cx="18.5" cy="14.5" r="0.6" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function TransformasiIcon() {
  return (
    <svg {...base}>
      <path d="M17 2.1 21 6l-4 3.9" />
      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
      <path d="M7 21.9 3 18l4-3.9" />
      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
    </svg>
  );
}

export function ResepIcon() {
  return (
    <svg {...base}>
      <rect x="4" y="3" width="12" height="12" rx="2" />
      <rect x="8" y="9" width="12" height="12" rx="2" />
    </svg>
  );
}

export function MobilIcon() {
  return (
    <svg {...base}>
      <path d="M3 16V12l2-5h6l3 5h4a2 2 0 0 1 2 2v2" />
      <circle cx="6.5" cy="17.5" r="1.8" />
      <circle cx="17.5" cy="17.5" r="1.8" />
      <path d="M3 16h4.7M11 16h9" />
    </svg>
  );
}

/** Pengeluaran — a receipt with a minus line (our own costs). */
export function PengeluaranIcon() {
  return (
    <svg {...base}>
      <path d="M5 3h14v18l-3-2-2 2-2-2-2 2-2-2-3 2z" />
      <path d="M9 11h6" />
    </svg>
  );
}

export function KontakIcon() {
  return (
    <svg {...base}>
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21c0-4.4 3.6-7 8-7s8 2.6 8 7" />
    </svg>
  );
}

export function PengaturanIcon() {
  return (
    <svg {...base}>
      <line x1="4" y1="7" x2="16" y2="7" />
      <circle cx="18" cy="7" r="2" />
      <line x1="8" y1="14" x2="20" y2="14" />
      <circle cx="6" cy="14" r="2" />
      <line x1="4" y1="21" x2="14" y2="21" />
      <circle cx="16" cy="21" r="2" />
    </svg>
  );
}

export function CollapseIcon({ className }) {
  return (
    <svg {...base} className={className}>
      <polyline points="11 17 6 12 11 7" />
      <polyline points="17 17 12 12 17 7" />
    </svg>
  );
}
